import { config } from "./screen-canvas-config";
import { useEffect, useState, useRef } from "react";

//@ts-ignore
const ScreenCanvas = ({
  //@ts-ignore
  fontSize,
  //@ts-ignore
  siteData,
  //@ts-ignore
  domain,
  //@ts-ignore
  extraVerticalPadding,
}) => {
  // #region Loading
  const [image, setImage] = useState(null);
  const [elements, setElements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    slots,
    lineWidth,
    screenshotWidth,
    screenshotHeight,
    canvasHeight,
    canvasWidth,
    padding,
    //@ts-ignore
    industrySector
  } = config;

  const imageFolder = `/industry/${industrySector}/images`;
  const jsonFolder = `/industry/${industrySector}`;


  console.log("siteData Keywords (inside component):", siteData?.keywords);
  const tooltipRefs = useRef([]);
  const [tooltipWidths, setTooltipWidths] = useState({});
  // #endregion 
  // Load Data
  useEffect(() => {
    const loadData = async () => {
      try {
        const imageName = `${domain}_desktop.webp`;
        const jsonName = `${domain}.json`;
        const imagePath = `${imageFolder}/${imageName}`;
        const jsonPath = `${jsonFolder}/${jsonName}`;

        const img = new Image();
        img.src = imagePath;
        await new Promise((resolve, reject) => {
          img.onload = () => resolve(img);
          img.onerror = () =>
            reject(new Error(`Failed to load image: ${imagePath}`));
        });

        const response = await fetch(jsonPath);
        if (!response.ok) throw new Error("Failed to load JSON");
        const jsonData = await response.json();

        const websiteData = jsonData[domain];
        if (!websiteData)
          throw new Error(`No data found for website: ${domain}`);

        const elements = websiteData.desktop.elements;
        if (!elements || !Array.isArray(elements)) {
          throw new Error("Invalid or missing 'elements' array in JSON data.");
        }
        //@ts-ignore
        setImage(img); 
        //@ts-ignore
        setElements(elements);
        setLoading(false);
      } catch (err) {
        //@ts-ignore
        setError(err.message);
        setLoading(false);
      }
    };

    loadData();
  }, [domain]);

  // ** NEW WIDTHS FOR TOOLTIPS - based on text length?
  useEffect(() => {
    if (tooltipRefs.current.length > 0) {
      const newWidths = {};
      tooltipRefs.current.forEach((ref, index) => {
        if (ref) {
          //@ts-ignore
          newWidths[index] = ref.offsetWidth;
        }
      });
      setTooltipWidths(newWidths);
    }
  }, [elements]);
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  // #region Loading

  //@ts-ignore
  const scaleX = screenshotWidth / image.width;
  //@ts-ignore
  const scaleY = screenshotHeight / image.height;
  const usedSlots = new Set();
  // #endregion Loading

  // Function to check if two lines intersect
  //@ts-ignore
  const doLinesIntersect = (line1, line2) => {
    const [x1, y1, x2, y2] = line1; // Line 1: (x1, y1) to (x2, y2)
    const [x3, y3, x4, y4] = line2; // Line 2: (x3, y3) to (x4, y4)

    // Calculate the denominator
    const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);

    // If the denominator is 0, the lines are parallel and do not intersect
    if (denominator === 0) return false;

    // Calculate the intersection point parameters
    const ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
    const ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;

    // Check if the intersection lies within both segments
    const epsilon = 0.0001; // Tolerance for floating-point precision
    return (
      ua >= -epsilon && ua <= 1 + epsilon && ub >= -epsilon && ub <= 1 + epsilon
    );
  };
  //@ts-ignore
  const calculateLine = (slot, boundingArea) => {
    const tooltipCenterX = padding + slot.x + slot.width / 2;
    const tooltipCenterY = padding + slot.y + slot.height / 2;
    const centerX = (boundingArea[0] + boundingArea[2]) / 2;
    const centerY = (boundingArea[1] + boundingArea[3]) / 2;

    console.log("Tooltip Center:", { x: tooltipCenterX, y: tooltipCenterY });
    console.log("Bounding Area Center:", { x: centerX, y: centerY });

    return [tooltipCenterX, tooltipCenterY, centerX, centerY];
  };

  // Function to check if two bounding areas overlap
  //@ts-ignore
  const doBoundingAreasOverlap = (area1, area2) => {
    const [x1, y1, x2, y2] = area1;
    const [x3, y3, x4, y4] = area2;

    return !(x2 <= x3 || x1 >= x4 || y2 <= y3 || y1 >= y4);
  };

  // #region Function to check for keyword matches
  //@ts-ignore
  const checkForKeywordMatches = (text, keywords) => {
    if (!text || !keywords) return [];
    //@ts-ignore
    return keywords.filter((keyword) =>
      text.toLowerCase().includes(keyword.toLowerCase())
    );
  };
  // #endregion

  const processElements = () => {
    //@ts-ignore
    const processedElements = [];
    //@ts-ignore
    const imgElements = []; // Track img elements to check for overlaps

    // Create a list of available slots
    const availableSlots = [...slots];

    // Sort elements by their position (e.g., top-to-bottom, left-to-right)
    const sortedElements = elements
      .map((element, index) => ({ element, index }))
      .sort((a, b) => {
        //@ts-ignore
        const aY = a.element.boundingArea[1];
        //@ts-ignore
        const bY = b.element.boundingArea[1];
        return aY - bY; // Sort by Y position (top-to-bottom)
      });

    // Process regular elements first
    sortedElements.forEach(({ element, index }) => {
      //@ts-ignore
      const boundingArea = element.boundingArea || [0, 0, 0, 0];

      // Skip invalid bounding areas
      if (
        boundingArea.length !== 4 ||
        //@ts-ignore
        boundingArea.every((val) => val === 0) ||
        boundingArea[0] <= 0 ||
        boundingArea[1] <= 0 || // Exclude negative values
        boundingArea[0] >= screenshotWidth + padding ||
        boundingArea[2] >= screenshotWidth + padding ||
        boundingArea[1] >= canvasHeight - padding || // Exclude elements exceeding screen bounds
        boundingArea[3] >= screenshotHeight // Exclude elements exceeding bottom edge of screenshot
      ) {
        return;
      }

      // Skip small images or elements with excluded keywords
      const isSmallImage =
        boundingArea[2] - boundingArea[0] <= 45 &&
        boundingArea[3] - boundingArea[1] <= 35;
      const hasExcludedKeywords = [
        "facebook",
        "google",
        "instagram",
        "twitter",
        "linkedin",
        "credit",
        "mastercard",
        "visa",
      ].some(
        (keyword) =>
          //@ts-ignore
          (element.filename &&
            //@ts-ignore
            element.filename.toLowerCase().includes(keyword)) ||
          //@ts-ignore
          (element.alt && element.alt.toLowerCase().includes(keyword))
      );

      if (isSmallImage || hasExcludedKeywords) {
        return;
      }

      // Transform bounding area based on scale and padding
      const transformedBoundingArea = [
        padding + boundingArea[0] * scaleX,
        padding + boundingArea[1] * scaleY,
        padding + boundingArea[2] * scaleX,
        padding + boundingArea[3] * scaleY,
      ];

      // Check for overlapping images (moved after transformedBoundingArea is defined)
      //@ts-ignore
      if (element.type === "img") {
        //@ts-ignore
        const isOverlapping = imgElements.some((img) =>
          doBoundingAreasOverlap(transformedBoundingArea, img.boundingArea)
        );

        if (isOverlapping) {
          console.log(`Skipping overlapping img element:`, element);
          return; // Skip overlapping img elements
        }

        imgElements.push({ element, boundingArea: transformedBoundingArea });
      }

      // Calculate the center of the transformed bounding area
      const centerX =
        (transformedBoundingArea[0] + transformedBoundingArea[2]) / 2;
      const centerY =
        (transformedBoundingArea[1] + transformedBoundingArea[3]) / 2;

      // Find the closest available slot
      let closestSlot = null;
      let minDistance = Infinity;

      availableSlots.forEach((slot) => {
        const slotCenterX = slot.x + slot.width / 2;
        const slotCenterY = slot.y + slot.height / 2;
        const distance = Math.sqrt(
          (slotCenterX - centerX) ** 2 + (slotCenterY - centerY) ** 2
        );

        if (distance < minDistance) {
          minDistance = distance;
          closestSlot = slot;
        }
      });

      // If no slot is found, skip rendering
      if (!closestSlot) {
        console.warn(`No slot found for element:`, element);
        return;
      }

      // Remove the assigned slot from available slots
      const slotIndex = availableSlots.indexOf(closestSlot);
      if (slotIndex !== -1) {
        availableSlots.splice(slotIndex, 1);
      }

      // Reduce width if the specific slot (x:10, y:400) overlaps with any bounding area
      //@ts-ignore
      if (closestSlot.x === 10 && closestSlot.y === 400) {
        const tooltipBoundingArea = [
          //@ts-ignore
          closestSlot.x,
          //@ts-ignore
          closestSlot.y,
          //@ts-ignore
          closestSlot.x + closestSlot.width,
          //@ts-ignore
          closestSlot.y + closestSlot.height,
        ];
        //@ts-ignore
        const overlaps = elements.some((e) =>
          //@ts-ignore
          doBoundingAreasOverlap(tooltipBoundingArea, e.boundingArea)
        );

        if (overlaps) {
          console.log("Overlap detected, reducing tooltip width to 370px");
          //@ts-ignore
          closestSlot.width = 370;
        }
      }

      // Tooltip description logic
      let description = "";
      let isEligibleForSlot = true;
      const newKeywords = ["move", "moving"];
      const keywordsToCheck = siteData?.keywords
        ? [...siteData.keywords, ...newKeywords]
        : newKeywords;
      console.log("Keywords to Check:", keywordsToCheck); // Debug log

      //@ts-ignore
      if (element.type === "placeholder") {
        //@ts-ignore
        description = element.text;
        //@ts-ignore
      } else if (["h1", "h2", "h3"].includes(element.type)) {
        //@ts-ignore
        const matchedKeywords = element.text
          //@ts-ignore
          ? checkForKeywordMatches(element.text, keywordsToCheck)
          : [];

        console.log("Matched Keywords:", matchedKeywords); // Debug log
        //@ts-ignore
        console.log("Element Text:", element.text); // Debug log
        console.log("Keywords:", siteData?.keywords); // Debug log

        if (matchedKeywords.length > 0) {
          description = `The heading contains the keyword${matchedKeywords.length > 1 ? "s" : ""
            } "${matchedKeywords.join('", "')}".`;
          isEligibleForSlot = false; // Not eligible if keywords are found
        } else {
          description = "The heading does not contain any keywords.";
          isEligibleForSlot = true; // Eligible if no keywords are found.
        }
      }
      //@ts-ignore
      else if (element.type === "img") {
        //@ts-ignore
        const imageMatchedKeywords = element.filename
          //@ts-ignore
          ? checkForKeywordMatches(element.filename, keywordsToCheck)
          : [];
        //@ts-ignore
        const altMatchedKeywords = element.alt
          //@ts-ignore
          ? checkForKeywordMatches(element.alt, keywordsToCheck)
          : [];

        if (imageMatchedKeywords.length > 0 && altMatchedKeywords.length > 0) {
          // Both filename and alt text contain keywords
          isEligibleForSlot = false; // Not eligible for a slot
          description = ""; // No message shown
        } else if (imageMatchedKeywords.length > 0) {
          // Only filename contains keywords
          isEligibleForSlot = true; // Eligible for a slot
          description = "The alternative text does not contain any keywords.";
        } else if (altMatchedKeywords.length > 0) {
          // Only alt text contains keywords
          isEligibleForSlot = true; // Eligible for a slot
          description = "The image filename does not contain any keywords.";
        } else {
          // Neither filename nor alt text contains keywords
          isEligibleForSlot = true; // Eligible for a slot
          description = "Both the image filename and alternative text contain no keywords.";
        }
      }
      // Skip rendering if the element is not eligible for a slot
      if (!isEligibleForSlot) {
        console.log(`Skipping ineligible element:`, element);
        return;
      }

      // Calculate the line from the slot to the bounding area
      const line = calculateLine(closestSlot, transformedBoundingArea);

      // Add the processed element
      processedElements.push({
        element,
        assignedSlot: closestSlot,
        line,
        boundingArea: transformedBoundingArea,
        description,
      });
    });

    // Check for intersections and swap slots if necessary
    for (let i = 0; i < processedElements.length; i++) {
      for (let j = i + 1; j < processedElements.length; j++) {
        //@ts-ignore
        const line1 = processedElements[i].line;
        //@ts-ignore
        const line2 = processedElements[j].line;

        if (doLinesIntersect(line1, line2)) {
          // Swap slots for the intersecting tooltips
          //@ts-ignore
          const temp = processedElements[i].assignedSlot;
          //@ts-ignore
          processedElements[i].assignedSlot = processedElements[j].assignedSlot;
          //@ts-ignore
          processedElements[j].assignedSlot = temp;

          // Recalculate lines after swapping
          //@ts-ignore
          processedElements[i].line = calculateLine(
            //@ts-ignore
            processedElements[i].assignedSlot,
            //@ts-ignore
            processedElements[i].boundingArea
          );
          //@ts-ignore
          processedElements[j].line = calculateLine(
            //@ts-ignore
            processedElements[j].assignedSlot,
            //@ts-ignore
            processedElements[j].boundingArea
          );
        }
      }
    }

    // Only process the following checks if there are available slots
    if (availableSlots.length > 0) {
      //@ts-ignore
      const hasH1 = elements.some(
        (el) =>
          //@ts-ignore
          el.type === "h1" &&
          //@ts-ignore
          el.text !== false &&
          //@ts-ignore
          el.boundingArea &&
          //@ts-ignore
          el.boundingArea.length === 4 &&
          //@ts-ignore
          !el.boundingArea.every((val) => val === 0)
      );

      // If no valid H1 is found, add a placeholder element to indicate no main heading
      if (!hasH1 && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "No main heading (H1) in the intro screen.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "No main heading (H1) in the intro screen.",
        });
        availableSlots.pop(); // Remove the last slot from available slots
      }

      // Additional checks for sitemap, robots.txt, and other conditions
      const sitemapPass = !!siteData?.sitemap;
      const robotsPass = !!siteData?.robotsTxt?.exists;

      if (!sitemapPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "There is no Sitemap.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "There is no Sitemap.",
        });
        availableSlots.pop();
      }

      if (!robotsPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "There is no Robots.txt.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "There is no Robots.txt.",
        });
        availableSlots.pop();
      }

      // PageSpeed checks
      //@ts-ignore
      const parseSpeedValue = (value) => {
        if (!value) return 0;
        return parseFloat(value.replace(/[^0-9.]/g, "")); // Remove non-numeric characters and parse
      };

      const speedIndexPass = parseSpeedValue(siteData?.pagespeed?.speedIndex) <= 2;
      const fcpPass = parseSpeedValue(siteData?.pagespeed?.firstContentfulPaint) <= 2;
      const interactivePass = parseSpeedValue(siteData?.pagespeed?.interactive) <= 3;
      const responsiveImagesPass = !siteData?.pagespeed?.usesResponsiveImages?.includes("Potential savings");
      const unminJSPass = !siteData?.pagespeed?.unminifiedJavaScript?.includes("Potential savings");
      const unminCSSPass = !siteData?.pagespeed?.unminifiedCss?.includes("Potential savings");
      const renderBlockingPass = !siteData?.pagespeed?.renderBlockingResources?.includes("Potential savings");
      const byteWeightPass = parseSpeedValue(siteData?.pagespeed?.totalByteWeight) <= 2000;
      const networkRequestsPass = siteData?.pagespeed?.networkRequests === "N/A";
      const redirectsPass = siteData?.pagespeed?.redirects === "N/A";
      const readabilityPass = siteData?.readability?.score > 70;
      const contentLengthPass = siteData?.contentLength?.status === true;
      const headingHierarchyPass = !!siteData?.headingHierarchy?.status;
      const annotatedWebpPass = !!siteData?.annotatedWebp;

      const hasPageSpeedFailure = !speedIndexPass || !fcpPass || !interactivePass;

      if (hasPageSpeedFailure && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "Page Speed issues detected.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "Page speed issues detected.",
        });
        availableSlots.pop();
      }

      // Responsive Images Check
      if (!responsiveImagesPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "The website uses images that are not responsive, which can negatively impact performance on different devices.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "The website uses images that are not responsive, which can negatively impact performance on different devices.",
        });
        availableSlots.pop();
      }

      // Unminified JavaScript Check
      if (!unminJSPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "The website contains JavaScript code that has not been compressed, which can increase load times.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "The website contains unminified JavaScript, which can increase load times.",
        });
        availableSlots.pop();
      }

      // Unminified CSS Check
      if (!unminCSSPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "The website contains unminified CSS, which can increase load times.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "The website contains unminified CSS, which can increase load times.",
        });
        availableSlots.pop();
      }

      // Render Blocking Resources Check
      if (!renderBlockingPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "The website has a lot of code that is not necessary for the most important content, so it makes the page slow.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "The website has render-blocking resources, which can delay page rendering.",
        });
        availableSlots.pop();
      }

      // Byte Weight Check
      if (!byteWeightPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "The website has a very high total file size, which slows down the loading of the page.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "The website has a high total byte weight, which can slow down page load times.",
        });
        availableSlots.pop();
      }

      // Network Requests Check
      if (!networkRequestsPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "The website downloads too many individual items, which significantly slows the page loading.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "The website downloads too many individual items, which significantly slows the page loading.",
        });
        availableSlots.pop();
      }

      // Redirects Check
      if (!redirectsPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "The website has unnecessary redirects, which can slow down page load times.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "The website has unnecessary redirects, which can slow down page load times.",
        });
        availableSlots.pop();
      }

      // Readability Check
      if (!readabilityPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "The website's readability score is below 70, which may affect user engagement.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "The website's readability score is below 70, which may affect user engagement.",
        });
        availableSlots.pop();
      }

      // Content Length Check
      if (!contentLengthPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "The website's content length is insufficient, which may impact SEO and user engagement.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "The website's content length is insufficient, which may impact SEO and user engagement.",
        });
        availableSlots.pop();
      }

      // Heading Hierarchy Check
      if (!headingHierarchyPass && availableSlots.length > 0) {
        const lastSlot = availableSlots[availableSlots.length - 1];
        processedElements.push({
          type: "placeholder",
          text: "The website's heading hierarchy is not properly structured, which can affect SEO and accessibility.",
          assignedSlot: lastSlot,
          boundingArea: [0, 0, 0, 0], // Dummy bounding area
          description: "The website's heading hierarchy is not properly structured, which can affect SEO and accessibility.",
        });
        availableSlots.pop();
      }

      // Annotated WebP Check
      // if (!annotatedWebpPass && availableSlots.length > 0) {
      //   const lastSlot = availableSlots[availableSlots.length - 1];
      //   processedElements.push({
      //     type: "placeholder",
      //     text: "The website does not use compressed WebP images, which can improve performance and reduce file sizes.",
      //     assignedSlot: lastSlot,
      //     boundingArea: [0, 0, 0, 0], // Dummy bounding area
      //     description: "The website does not use compressed WebP images, which can improve performance and reduce file sizes.",
      //   });
      //   availableSlots.pop();
      // }
    }

    return processedElements;
  };

  const processedElements = processElements();

  console.log("Processed Elements:", processedElements);

  return (
    <div
      style={{
        position: "relative",
        overflow: "visible"
      }}
      className="tooltips"
    >
      <div
        style={{
          position: "relative",
          borderRadius: "16px",
          width: `${canvasWidth + extraVerticalPadding}px`,
          height: "4000px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: padding,
            left: padding,
            width: `${screenshotWidth - 20}px`,
            height: `${canvasHeight + extraVerticalPadding}px`,
            borderRadius: "16px", // Rounded corners
            overflow: "hidden", // Ensures clipped content doesn't show
          }}
        >
          {/* to make website component responsive:

          determine screensizes for each breakpoint: 320, 640, 992, 1024, 1200, 1600
          screenshot image width - for each breakpoint
          screenshotWidth for each breakpoint
          tooltips:
          - right tooltip left coordinates
          - maxWidth for each breakpoint
          fontSize for each breakpoint */}

          <img
            //@ts-ignore
            src={image.src}
            alt="Website Screenshot"
            style={{
              width: `${screenshotWidth}px`,
              height: `${screenshotHeight}px`,
              objectFit: "cover",
              // transform: "translateX(-20px)", // Moves the image left by 20px
            }}
          />
        </div>
      </div>
      {Object.entries(processedElements).map(([key, element]) => {
        const index = parseInt(key, 10); // Convert the key (string) to a number
        const { assignedSlot, boundingArea, description, type } = element;
        // if (!assignedSlot) {
        //   console.warn(`Skipping element at index ${index} due to missing assignedSlot`);
        //   return null;
        // }


        //@ts-ignore
        const tooltipWidth = tooltipWidths[index] || 300;
        const centerX = (boundingArea[0] + boundingArea[2]) / 2;
        const centerY = (boundingArea[1] + boundingArea[3]) / 2;
        const lineStartX = assignedSlot.x + tooltipWidth / 2;
        const lineStartY = assignedSlot.y;
        if (!assignedSlot) {
          console.warn(`Skipping element at index ${index} due to missing assignedSlot`);
          return null;
        }
        // Set the tooltip width based on assignedSlot.y and assignedSlot.x
        const widthHere =
          assignedSlot.y === 400 && assignedSlot.x === 10 ? 370 : 'auto'; // Apply 370px width if y=400 and x=10, otherwise 'auto'

        return (

          <div key={index}>
            {/* Skip rendering the line for placeholder elements */}
            {/* @ts-ignore */}
            {type !== "placeholder" && (
              <div
                //@ts-ignore
                className={index}
                style={{
                  position: "absolute",
                  top: lineStartY,
                  left: lineStartX,
                  width: Math.sqrt(
                    (centerX - lineStartX) ** 2 + (centerY - lineStartY) ** 2
                  ),
                  height: lineWidth,
                  backgroundColor: "black",
                  transform: `rotate(${Math.atan2(
                    centerY - lineStartY,
                    centerX - lineStartX
                  )}rad)`,
                  transformOrigin: "0 0",
                }}
              />
            )}
            <div
              //@ts-ignore
              ref={(el) => (tooltipRefs.current[index] = el)}
              style={{
                position: "absolute",
                letterSpacing: '-1px',
                top: assignedSlot.y,
                left: assignedSlot.x,
                width: widthHere, // Use the conditional widthHere
                minWidth: "300px",
                maxWidth: "1000px",
                backgroundColor: "white",
                border: "2px solid black",
                color: "#333",
                borderRadius: "40px",
                padding: "15px 15px 20px 25px",
                fontSize: `${fontSize}px`,
                lineHeight: 1.2,
                pointerEvents: "none",
                zIndex: 10,
              }}
            >
              {description}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ScreenCanvas;
